<template>
  <div>
    <div class="flex flex-col justify-center mt-5">
      <h1 class="px-10 py-4 bg-green-400 font-bold text-white mb-3 text-center">
        {{ $t('checkout.order-placed') }}
      </h1>
      <div class="text-center">
        <button class="bg-redish rounded text-white font-bold px-6 py-1 mx-auto" @click="$router.push('/')">
          Home
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  created() {
    this.$store.dispatch('cart/reset');
  },
};
</script>
